module.exports = __webpack_public_path__ + "img/icon340.70911f59.png";